import defaultStore from '../defaultStore';

const { store } = defaultStore('venusa/faturamento', 'faturamento');

export default {
  ...store,
};
